// GENERATED FILE - DO NOT MODIFY
import { CatalogInventoryModel } from "api/models/company/catalog/catalog-inventory-model";
import { DocumentModel } from "api/models/company/document/document-model";
import { DocumentSectionModel } from "api/models/company/document/document-section-model";
import { ListDocumentModel } from "api/models/company/document/list-document-model";
import { InventorySiteTransferDetailsModel } from "api/models/company/inventory-site-transfer-details-model";
import { InventorySiteTransferItemModel } from "api/models/company/inventory-site-transfer-item-model";
import { InventorySiteTransferItemResponseModel } from "api/models/company/inventory-site-transfer-item-response-model";
import { InventorySiteTransferModel } from "api/models/company/inventory-site-transfer-model";
import { InventorySiteTransferUpdateFromCatalogInventoryModel } from "api/models/company/inventory-site-transfer-update-from-catalog-inventory-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class InventorySiteTranferProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async SaveTransfer(inventorySiteTransferDetails: InventorySiteTransferDetailsModel | null, requestConfig?: HttpClientRequestConfig): Promise<number> {
        const uri = this.buildUri(
            "/inventory-site-transfer",
            null,
            null
        );

        const data: number = await this.post<InventorySiteTransferDetailsModel | null, number>(uri, inventorySiteTransferDetails, requestConfig);
        return data;
    }

    public async SaveTransferItems(items: Array<InventorySiteTransferItemModel | null> | null, requestConfig?: HttpClientRequestConfig): Promise<boolean> {
        const uri = this.buildUri(
            "/inventory-site-transfer/items",
            null,
            null
        );

        const data: boolean = await this.post<Array<InventorySiteTransferItemModel | null> | null, boolean>(uri, items, requestConfig);
        return data;
    }

    public async NewTransfer(requestConfig?: HttpClientRequestConfig): Promise<InventorySiteTransferDetailsModel | null> {
        const uri = this.buildUri(
            "/inventory-site-transfer/new",
            null,
            null
        );

        const data: InventorySiteTransferDetailsModel | null = await this.get<InventorySiteTransferDetailsModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.InventorySiteTransferDetailsModel");
        return data;
    }

    public async NewTransferItem(transferId: number, productCode: string | null, sourceSiteId: string | null, targetSiteId: string | null, requestConfig?: HttpClientRequestConfig): Promise<InventorySiteTransferItemResponseModel | null> {
        const uri = this.buildUri(
            "/inventory-site-transfer/{transferId}/item/new",
            { transferId: (transferId === null || transferId === undefined) ? undefined : transferId.toString() },
            { productCode: (productCode === null || productCode === undefined) ? undefined : productCode, sourceSiteId: (sourceSiteId === null || sourceSiteId === undefined) ? undefined : sourceSiteId, targetSiteId: (targetSiteId === null || targetSiteId === undefined) ? undefined : targetSiteId }
        );

        const data: InventorySiteTransferItemResponseModel | null = await this.get<InventorySiteTransferItemResponseModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.InventorySiteTransferItemResponseModel");
        return data;
    }

    public async UpdateFromCatalogInventoryItem(updateModel: InventorySiteTransferUpdateFromCatalogInventoryModel | null, requestConfig?: HttpClientRequestConfig): Promise<InventorySiteTransferItemModel | null> {
        const uri = this.buildUri(
            "/inventory-site-transfer/item/update-catalog-inventory-item",
            null,
            null
        );

        const data: InventorySiteTransferItemModel | null = await this.post<InventorySiteTransferUpdateFromCatalogInventoryModel | null, InventorySiteTransferItemModel | null>(uri, updateModel, requestConfig);
        this.transformModels(data, "Company.InventorySiteTransferItemModel");
        return data;
    }

    public async AddReservations(transferId: number, sourceSiteId: string | null, targetSiteId: string | null, selectedReservations: Array<CatalogInventoryModel | null> | null, requestConfig?: HttpClientRequestConfig): Promise<InventorySiteTransferDetailsModel | null> {
        const uri = this.buildUri(
            "/inventory-site-transfer/{transferId}/items/add-reservations",
            { transferId: (transferId === null || transferId === undefined) ? undefined : transferId.toString() },
            { sourceSiteId: (sourceSiteId === null || sourceSiteId === undefined) ? undefined : sourceSiteId, targetSiteId: (targetSiteId === null || targetSiteId === undefined) ? undefined : targetSiteId }
        );

        const data: InventorySiteTransferDetailsModel | null = await this.post<Array<CatalogInventoryModel | null> | null, InventorySiteTransferDetailsModel | null>(uri, selectedReservations, requestConfig);
        this.transformModels(data, "Company.InventorySiteTransferDetailsModel");
        return data;
    }

    public async UpdateTransferItems(inventorySiteTransferDetails: InventorySiteTransferDetailsModel | null, requestConfig?: HttpClientRequestConfig): Promise<InventorySiteTransferDetailsModel | null> {
        const uri = this.buildUri(
            "/inventory-site-transfer/update/items",
            null,
            null
        );

        const data: InventorySiteTransferDetailsModel | null = await this.post<InventorySiteTransferDetailsModel | null, InventorySiteTransferDetailsModel | null>(uri, inventorySiteTransferDetails, requestConfig);
        this.transformModels(data, "Company.InventorySiteTransferDetailsModel");
        return data;
    }

    public async GetTransferItem(sourceTransactionNumber: number, targetTransactionNumber: number, requestConfig?: HttpClientRequestConfig): Promise<InventorySiteTransferItemResponseModel | null> {
        const uri = this.buildUri(
            "/inventory-site-transfer/item/{sourceTransactionNumber}/{targetTransactionNumber}",
            { sourceTransactionNumber: (sourceTransactionNumber === null || sourceTransactionNumber === undefined) ? undefined : sourceTransactionNumber.toString(), targetTransactionNumber: (targetTransactionNumber === null || targetTransactionNumber === undefined) ? undefined : targetTransactionNumber.toString() },
            null
        );

        const data: InventorySiteTransferItemResponseModel | null = await this.get<InventorySiteTransferItemResponseModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.InventorySiteTransferItemResponseModel");
        return data;
    }

    public async DeleteTransferItem(sourceTransactionNumber: number, targetTransactionNumber: number, requestConfig?: HttpClientRequestConfig): Promise<boolean> {
        const uri = this.buildUri(
            "/inventory-site-transfer/item/{sourceTransactionNumber}/{targetTransactionNumber}",
            { sourceTransactionNumber: (sourceTransactionNumber === null || sourceTransactionNumber === undefined) ? undefined : sourceTransactionNumber.toString(), targetTransactionNumber: (targetTransactionNumber === null || targetTransactionNumber === undefined) ? undefined : targetTransactionNumber.toString() },
            null
        );

        const data: boolean = await this.delete<boolean>(uri, requestConfig);
        return data;
    }

    public async IsServiceCallInstalled(requestConfig?: HttpClientRequestConfig): Promise<boolean> {
        const uri = this.buildUri(
            "/inventory-site-transfer/service-call/installed",
            null,
            null
        );

        const data: boolean = await this.get<boolean>(uri, requestConfig);
        return data;
    }

    public async GetTransfers(onlyClose: boolean, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<InventorySiteTransferModel[] | null> {
        const uri = this.buildUri(
            "/inventory-site-transfer",
            null,
            { onlyClose: (onlyClose === null || onlyClose === undefined) ? undefined : onlyClose.toString(), filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: InventorySiteTransferModel[] | null = await this.get<InventorySiteTransferModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.InventorySiteTransferModel");
        return data;
    }

    public async GetTransfer(transferId: number, requestConfig?: HttpClientRequestConfig): Promise<InventorySiteTransferDetailsModel | null> {
        const uri = this.buildUri(
            "/inventory-site-transfer/{transferId}",
            { transferId: (transferId === null || transferId === undefined) ? undefined : transferId.toString() },
            null
        );

        const data: InventorySiteTransferDetailsModel | null = await this.get<InventorySiteTransferDetailsModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.InventorySiteTransferDetailsModel");
        return data;
    }

    public async GetTransferHeader(transferId: number, requestConfig?: HttpClientRequestConfig): Promise<InventorySiteTransferDetailsModel | null> {
        const uri = this.buildUri(
            "/inventory-site-transfer/header/{transferId}",
            { transferId: (transferId === null || transferId === undefined) ? undefined : transferId.toString() },
            null
        );

        const data: InventorySiteTransferDetailsModel | null = await this.get<InventorySiteTransferDetailsModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.InventorySiteTransferDetailsModel");
        return data;
    }

    public async DeleteTransfer(transferId: number, requestConfig?: HttpClientRequestConfig): Promise<boolean> {
        const uri = this.buildUri(
            "/inventory-site-transfer/{transferId}",
            { transferId: (transferId === null || transferId === undefined) ? undefined : transferId.toString() },
            null
        );

        const data: boolean = await this.delete<boolean>(uri, requestConfig);
        return data;
    }

    public async Complete(transferId: number, requestConfig?: HttpClientRequestConfig): Promise<void> {
        const uri = this.buildUri(
            "/inventory-site-transfer/{transferId}/complete",
            { transferId: (transferId === null || transferId === undefined) ? undefined : transferId.toString() },
            null
        );

        await this.post<void, void>(uri, undefined, requestConfig);
    }

    public async GetDocumentsByTransferId(transferId: number, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<ListDocumentModel[] | null> {
        const uri = this.buildUri(
            "/inventory-site-transfer/{transferId}/documents",
            { transferId: (transferId === null || transferId === undefined) ? undefined : transferId.toString() },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: ListDocumentModel[] | null = await this.get<ListDocumentModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Document.ListDocumentModel");
        return data;
    }

    public async GetSections(transferId: number, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<DocumentSectionModel[] | null> {
        const uri = this.buildUri(
            "/inventory-site-transfer/{transferId}/documents/sections",
            { transferId: (transferId === null || transferId === undefined) ? undefined : transferId.toString() },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: DocumentSectionModel[] | null = await this.get<DocumentSectionModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Document.DocumentSectionModel");
        return data;
    }

    public async AddDocumentForTransfer(transferId: number, models: Array<DocumentModel | null> | null, dispatchTemplateId: string | null, requestConfig?: HttpClientRequestConfig): Promise<boolean> {
        const uri = this.buildUri(
            "/inventory-site-transfer/{transferId}/documents",
            { transferId: (transferId === null || transferId === undefined) ? undefined : transferId.toString() },
            { dispatchTemplateId: (dispatchTemplateId === null || dispatchTemplateId === undefined) ? undefined : dispatchTemplateId }
        );

        const data: boolean = await this.post<Array<DocumentModel | null> | null, boolean>(uri, models, requestConfig);
        return data;
    }
}
